import React from "react";
import { supabase } from "@/integrations/supabase/client";

const WorkHero = () => {
  const { data } = supabase.storage
    .from('article-images')
    .getPublicUrl('wkzkzg413wk-1757272450000.JPEG');
    
  console.log('WorkHero image URL:', data.publicUrl);
    
  return (
    <div className="relative">
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${data.publicUrl})`,
          }}
        >
          <div className="absolute inset-0 bg-black/30" />
        </div>
        
        <div className="relative container mx-auto px-4 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 drop-shadow-lg">Our Work</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto drop-shadow-md">
            Supporting and representing the seed potato industry through research, collaboration, and advocacy.
          </p>
        </div>
      </section>
    </div>
  );
};

export default WorkHero;